// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__xW5_6","rootSuccess":"CompleteLink_rootSuccess__13h8H","rootFailure":"CompleteLink_rootFailure__w6c7P","isDisabled":"CompleteLink_isDisabled__1k1Zc"};